/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: nJ1Nn58LcfAm7wemZm71QH
// Component: vtiP6mjKQi__
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  useCurrentUser
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import ButtonActionPictogram from "../../ButtonActionPictogram"; // plasmic-import: hophp8l6gJc0/component
import Op1WebFrameWindowControl from "../../OP1WebFrameWindowControl"; // plasmic-import: EQLX5d3CNuxY/codeComponent
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/projectcss
import sty from "./PlasmicOp1WebWindowTabHead.module.css"; // plasmic-import: vtiP6mjKQi__/css
import image9ARcsVGaJAiQd from "./images/image9.svg"; // plasmic-import: ARcsVGaJAiQD/picture
import image57JdTpv3KCx2Fl from "./images/image57.svg"; // plasmic-import: jdTPV3KCx2FL/picture
import image73Ej7HXzcFMlt0 from "./images/image73.svg"; // plasmic-import: ej7HXzcFMlt0/picture
import image6740GeZjck4Ww5 from "./images/image67.svg"; // plasmic-import: 40GeZJCK4WW5/picture
import image659Gjv2GpUan12 from "./images/image65.svg"; // plasmic-import: 9GJV2GPUan12/picture

createPlasmicElementProxy;

export const PlasmicOp1WebWindowTabHead__VariantProps = new Array();

export const PlasmicOp1WebWindowTabHead__ArgProps = new Array(
  "onClickCloseButton",
  "onClickMaximizeButton",
  "windowTitle",
  "appWindowIcon",
  "crumb1Title",
  "onClickBackButton",
  "showMaximizeButton",
  "showBackButton",
  "showCrumb1"
);

const $$ = {};

function PlasmicOp1WebWindowTabHead__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          windowTitle: "title",
          appWindowIcon: {
            src: image9ARcsVGaJAiQd,
            fullWidth: 20,
            fullHeight: 20,
            aspectRatio: undefined
          },
          crumb1Title: "crumb1",
          showMaximizeButton: false,
          showBackButton: false,
          showCrumb1: false
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"headWrapper"}
      data-plasmic-override={overrides.headWrapper}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_nJ1Nn58LcfAm7wemZm71QH",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.headWrapper
      )}
    >
      <div
        data-plasmic-name={"left"}
        data-plasmic-override={overrides.left}
        className={classNames("all", sty.left)}
      >
        {(() => {
          try {
            return $props.showBackButton;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return true;
            }
            throw e;
          }
        })() ? (
          <ButtonActionPictogram
            className={classNames(
              "__wab_instance",
              sty.buttonActionPictogram__kbRkL
            )}
            color={"transparentBg"}
            onClick={async () => {
              const $steps = {};
              $steps["runOnClickBackButton"] = true
                ? (() => {
                    const actionArgs = {
                      eventRef: $props["onClickBackButton"]
                    };
                    return (({ eventRef, args }) => {
                      return eventRef?.(...(args ?? []));
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["runOnClickBackButton"] != null &&
                typeof $steps["runOnClickBackButton"] === "object" &&
                typeof $steps["runOnClickBackButton"].then === "function"
              ) {
                $steps["runOnClickBackButton"] =
                  await $steps["runOnClickBackButton"];
              }
            }}
            pictogram={{
              src: image57JdTpv3KCx2Fl,
              fullWidth: 20,
              fullHeight: 20,
              aspectRatio: undefined
            }}
            shape={"globalRounding"}
            size={"medium"}
            status={"normal"}
          />
        ) : null}
        <ButtonActionPictogram
          className={classNames(
            "__wab_instance",
            sty.buttonActionPictogram__lWd1W
          )}
          color={"transparentBg"}
          pictogram={(() => {
            try {
              return $props.appWindowIcon;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return {
                  src: image73Ej7HXzcFMlt0,
                  fullWidth: 20,
                  fullHeight: 20,
                  aspectRatio: undefined
                };
              }
              throw e;
            }
          })()}
          shape={"globalRounding"}
          size={"medium"}
          status={"disabled"}
        />

        <div className={classNames("all", "__wab_text", sty.text__rgG0T)}>
          <React.Fragment>
            {(() => {
              try {
                return $props.windowTitle;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "conversations.";
                }
                throw e;
              }
            })()}
          </React.Fragment>
        </div>
        {(() => {
          try {
            return $props.showCrumb1;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return true;
            }
            throw e;
          }
        })() ? (
          <div
            data-plasmic-name={"crumb1Wrapper"}
            data-plasmic-override={overrides.crumb1Wrapper}
            className={classNames("all", sty.crumb1Wrapper)}
          >
            <div className={classNames("all", "__wab_text", sty.text__w1Ein)}>
              {"/"}
            </div>
            <div className={classNames("all", "__wab_text", sty.text__enwl2)}>
              <React.Fragment>
                {(() => {
                  try {
                    return $props.crumb1Title;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return "crumb1";
                    }
                    throw e;
                  }
                })()}
              </React.Fragment>
            </div>
          </div>
        ) : null}
      </div>
      <div
        data-plasmic-name={"buttons"}
        data-plasmic-override={overrides.buttons}
        className={classNames("all", sty.buttons)}
      >
        {(() => {
          try {
            return $props.showMaximizeButton;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return true;
            }
            throw e;
          }
        })() ? (
          <ButtonActionPictogram
            className={classNames(
              "__wab_instance",
              sty.buttonActionPictogram__cReTl
            )}
            color={"transparentBg"}
            onClick={async () => {
              const $steps = {};
              $steps["runOnClickMaximizeButton"] = true
                ? (() => {
                    const actionArgs = {
                      eventRef: $props["onClickMaximizeButton"]
                    };
                    return (({ eventRef, args }) => {
                      return eventRef?.(...(args ?? []));
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["runOnClickMaximizeButton"] != null &&
                typeof $steps["runOnClickMaximizeButton"] === "object" &&
                typeof $steps["runOnClickMaximizeButton"].then === "function"
              ) {
                $steps["runOnClickMaximizeButton"] =
                  await $steps["runOnClickMaximizeButton"];
              }
            }}
            pictogram={{
              src: image6740GeZjck4Ww5,
              fullWidth: 20,
              fullHeight: 20,
              aspectRatio: undefined
            }}
            shape={"globalRounding"}
            size={"medium"}
            status={"normal"}
          />
        ) : null}
        <Op1WebFrameWindowControl
          data-plasmic-name={"op1WebFrameWindowControlPilot"}
          data-plasmic-override={overrides.op1WebFrameWindowControlPilot}
          action={"close"}
          className={classNames(
            "__wab_instance",
            sty.op1WebFrameWindowControlPilot
          )}
        >
          <PlasmicImg__
            data-plasmic-name={"img"}
            data-plasmic-override={overrides.img}
            alt={""}
            className={classNames(sty.img)}
            displayHeight={"auto"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"auto"}
            loading={"lazy"}
            src={{
              src: image659Gjv2GpUan12,
              fullWidth: 20,
              fullHeight: 20,
              aspectRatio: undefined
            }}
          />
        </Op1WebFrameWindowControl>
        <ButtonActionPictogram
          className={classNames(
            "__wab_instance",
            sty.buttonActionPictogram__iepNq
          )}
          color={"transparentBg"}
          onClick={async () => {
            const $steps = {};
            $steps["runOnClickCloseButton"] = true
              ? (() => {
                  const actionArgs = { eventRef: $props["onClickCloseButton"] };
                  return (({ eventRef, args }) => {
                    return eventRef?.(...(args ?? []));
                  })?.apply(null, [actionArgs]);
                })()
              : undefined;
            if (
              $steps["runOnClickCloseButton"] != null &&
              typeof $steps["runOnClickCloseButton"] === "object" &&
              typeof $steps["runOnClickCloseButton"].then === "function"
            ) {
              $steps["runOnClickCloseButton"] =
                await $steps["runOnClickCloseButton"];
            }
          }}
          pictogram={{
            src: image659Gjv2GpUan12,
            fullWidth: 20,
            fullHeight: 20,
            aspectRatio: undefined
          }}
          shape={"globalRounding"}
          size={"medium"}
          status={"normal"}
        />
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  headWrapper: [
    "headWrapper",
    "left",
    "crumb1Wrapper",
    "buttons",
    "op1WebFrameWindowControlPilot",
    "img"
  ],

  left: ["left", "crumb1Wrapper"],
  crumb1Wrapper: ["crumb1Wrapper"],
  buttons: ["buttons", "op1WebFrameWindowControlPilot", "img"],
  op1WebFrameWindowControlPilot: ["op1WebFrameWindowControlPilot", "img"],
  img: ["img"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOp1WebWindowTabHead__ArgProps,
          internalVariantPropNames: PlasmicOp1WebWindowTabHead__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOp1WebWindowTabHead__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "headWrapper") {
    func.displayName = "PlasmicOp1WebWindowTabHead";
  } else {
    func.displayName = `PlasmicOp1WebWindowTabHead.${nodeName}`;
  }
  return func;
}

export const PlasmicOp1WebWindowTabHead = Object.assign(
  // Top-level PlasmicOp1WebWindowTabHead renders the root element
  makeNodeComponent("headWrapper"),
  {
    // Helper components rendering sub-elements
    left: makeNodeComponent("left"),
    crumb1Wrapper: makeNodeComponent("crumb1Wrapper"),
    buttons: makeNodeComponent("buttons"),
    op1WebFrameWindowControlPilot: makeNodeComponent(
      "op1WebFrameWindowControlPilot"
    ),
    img: makeNodeComponent("img"),
    // Metadata about props expected for PlasmicOp1WebWindowTabHead
    internalVariantProps: PlasmicOp1WebWindowTabHead__VariantProps,
    internalArgProps: PlasmicOp1WebWindowTabHead__ArgProps
  }
);

export default PlasmicOp1WebWindowTabHead;
/* prettier-ignore-end */
